import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import styles from "../App.module.scss";
import ENV from "../Environments";
import * as LazyComponents from "./loadables";
import LoaderComponent from "../atoms/Loader";

const AppRoutes = () => {
	return (
		<>
			<Router basename={ENV.getBaseName()}>
				<Suspense
					fallback={
						<div className={styles.loaderWrap}>
							<LoaderComponent />
						</div>
					}
				>
					<Routes>
						<Route
							path={"/:templateName"}
							element={<LazyComponents.LandingComponent />}
						/>
					</Routes>
				</Suspense>
			</Router>
		</>
	);
};

export default AppRoutes;
